import React from 'react';
import PropTypes from 'prop-types';

const PriceTypeExisting = ({ description, handleRemoval }) => {
  return (
    <div className="syos-pricetype-unit">
      <span className="syos-pricetype-unit__details">
        <span className="syos-pricetype-unit__type">{description}</span>
      </span>
      <span className="syos-pricetype-unit__action">
        <button className="syos-button" onClick={handleRemoval}>
          Remove
        </button>
      </span>
    </div>
  );
};
PriceTypeExisting.propTypes = {
  description: PropTypes.string,
  handleRemoval: PropTypes.func
};

export default PriceTypeExisting;



// WEBPACK FOOTER //
// ./src/javascripts/components/PriceTypeExisting.js